import script from "./MyDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./MyDashboard.vue?vue&type=script&setup=true&lang=js"

import "./MyDashboard.vue?vue&type=style&index=0&id=64f8cf2a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64f8cf2a"]])

export default __exports__